import moment from "moment";
import { formatPrice, getPaymentStatusText, paymentMode } from "../../../../_metronic/helpers/utils";

const PaymentHistoryModalForm = ({
  selectedBookingId,
  setSelectedBookingId,
  setOpenPaymentHistoryModal,
}) => {

  const cancel = () => {
    setSelectedBookingId(null)
    setOpenPaymentHistoryModal(false);
  };

  return (
    <>
      <div className="kt_body">
        <div className="d-flex justify-content-between mb-2">
          <h4>Total Paid: {formatPrice(selectedBookingId?.bills?.filter((el) => el.status === 1).reduce((acc, el) => acc + (el.paid + el.redeemed || 0), 0)) || '$0'}</h4>
          <h4>Total Payout Amount: {formatPrice(selectedBookingId?.bills?.filter((el) => el.status === 1).reduce((acc, el) => acc + (el.payout_amount - el.payout_reversal || 0), 0)) || '$0'}</h4>
        </div>
        <div style={{ maxHeight: '300px', overflowY: 'auto', minHeight: 'auto', display: 'grid', gap: '10px', gridTemplateColumns: '1fr 1fr' }}>
          {
            selectedBookingId?.bills && selectedBookingId?.bills?.length > 0 ?
              <>
                {selectedBookingId?.bills?.map((item, index) => {
                  return <div
                    className="form-check form-check-custom form-check-solid bg-light d-flex justify-content-between align-items-center flex-wrap p-3"
                    style={{ borderRadius: '10px'}}
                    key={index}
                  >
                    <div className="fv-row w-50">
                      <label className="fw-bold fs-6 mb-2">Payment Date</label>
                      <h5 className="text-main fw-bold">{moment(item.date).format('MMM DD, YYYY')}</h5>
                    </div>
                    <div className="fv-row w-50" style={{ textAlign: "right" }}>
                      <label className="fw-bold fs-6 mb-2">Status</label>
                      <h5 className={`fw-bold text-${getPaymentStatusText(item.status)?.colorClass}`}>
                        {getPaymentStatusText(item.status)?.text}
                      </h5>
                    </div>
                    <div className="fv-row w-50">
                      <label className="fw-bold fs-6 mb-2">Booking Amount</label>
                      <h5 className="text-main fw-bold">{formatPrice(item?.total) || '$0'}</h5>
                    </div>
                    <div className="fv-row w-50" style={{ textAlign: "right" }}>
                      <label className="fw-bold fs-6 mb-2">Discount</label>
                      <h5 className="text-main fw-bold">{formatPrice(item?.discount_amount) || '$0'}</h5>
                    </div>
                    <div className="fv-row w-50">
                      <label className="fw-bold fs-6 mb-2">Tax</label>
                      <h5 className="text-main fw-bold">{formatPrice(item?.tax) || '$0'}</h5>
                    </div>
                    <div className="fv-row w-50" style={{ textAlign: "right" }}>
                      <label className="fw-bold fs-6 mb-2">Paid Amount</label>
                      <h5 className="text-main fw-bold">{formatPrice(item?.paid + item?.redeemed) || '$0'}</h5>
                    </div>
                    <div className="fv-row w-50">
                      <label className="fw-bold fs-6 mb-2">Payout Amount</label>
                      <h5 className="text-main fw-bold">{formatPrice(item?.payout_amount - item?.payout_reversal) || '$0'}</h5>
                    </div>
                    <div className="fv-row w-50" style={{ textAlign: "right" }}>
                      <label className="fw-bold fs-6 mb-2">Club Cash Earned</label>
                      <h5 className="text-main fw-bold">{formatPrice(item?.club_cash?.cash_earned) || '$0'}</h5>
                    </div>
                    <div className="fv-row w-50">
                      <label className="fw-bold fs-6 mb-2">Payment Method</label>
                      <h5 className="text-main fw-bold">{paymentMode[item?.payment_mode]}</h5>
                    </div>
                  </div>
                })}
              </>
              :
              <div className="form-check form-check-custom form-check-solid d-flex align-items-center justify-content-between flex-wrap pointer">
                <div style={{ display: "flex", gap: "10px" }}>
                  <span style={{ fontWeight: "bold" }}>
                    No Payment History
                  </span>
                </div>
              </div>
          }
        </div>
        <div className="d-flex justify-content-center">
          <button
            type="button"
            className="btn mt-4 btn-primary fw-bold text-white"
            onClick={() => cancel()}
          >
            Go Back
          </button>
        </div>
      </div>
    </>
  );
};

export { PaymentHistoryModalForm };
